import Script from 'next/script'

import { initScript as bingInitScript } from '@repo/analytics/bing'
import {
  initScript as facebookPixelInitScript,
  FacebookPixel as FacebookPixelImage,
} from '@repo/analytics/facebook'
import { GlobalSiteTag } from './global-site-tag'
import { GlobalOneTapLogin } from './global-one-tap-login'
import { Clarity } from './clarity'

const Bing = () => {
  return (
    <Script id="bing-script" strategy="afterInteractive">
      {bingInitScript}
    </Script>
  )
}

const FacebookPixel = () => {
  return (
    <>
      <Script id="facebook-pixel-script" strategy="afterInteractive">
        {facebookPixelInitScript}
      </Script>
      <FacebookPixelImage />
    </>
  )
}

interface AnalyticsProps {
  userId?: string
}

export const Analytics = ({ userId }: AnalyticsProps = {}) => {
  return (
    <>
      <GlobalOneTapLogin />
      <GlobalSiteTag />
      <FacebookPixel />
      <Bing />
      <Clarity userId={userId} />
    </>
  )
}
